import React, {useEffect, useMemo, useState} from "react";
import {Col, Spin, Grid} from "antd";
import _ from "lodash";
import {EnvironmentOutlined} from "@ant-design/icons";

import {
    CityFilter,
    IntegrationTypeFilter,
    ManagerCompanyFilter,
    PoolActivityFilter,
    SearchText,
    SearchTextWithDebounce
} from "../../../_defaultComponents/FilterComponents";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import PoolsListModal from "../poolsListModal/PoolsListModal";
import {useCitiesForPools} from "../../../../hooks/useCitiesForPools";
import {citiesToRestrictedCities} from "../../../../utils/citiesToRestrictedCities";
import {useStore} from "../../../../hooks/useStore";

const {useBreakpoint} = Grid;

const Filters = ({setCurrentPage, filters, setFilters}) => {
    const stores = useStore();
    const isAdmin = stores.meStore.checkRole("isAdmin");
    const [city, setCity] = useState(filters.city);
    const [integrationType, setIntegrationType] = useState(filters.integrationType);
    const [status, setStatus] = useState(filters.status);
    const [searchText, setSearchText] = useState(filters.searchText);
    const [managerCompany, setManagerCompany] = useState(filters.managerCompany || "all");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const {loading, cities: citiesData} = useCitiesForPools();
    const restrictedCities = useMemo(() => citiesToRestrictedCities(citiesData), [citiesData]);
    const screens = useBreakpoint();
    const isMobile = !screens.md;

    useEffect(() => {
        setCurrentPage(1);
    }, [city, integrationType, status, searchText, managerCompany]);

    useEffect(() => {
        const newFilters = {city, integrationType, status, searchText, managerCompany};
        if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
            setFilters(newFilters);
        }
    }, [city, integrationType, status, searchText, managerCompany]);

    return (
        <React.Fragment>
            <div
                style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    gap: isMobile ? "0px" : "8px",
                    justifyContent: isMobile ? "flex-start" : "space-between",
                    width: "100%"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        gap: isMobile ? "0px" : "8px",
                        width: "100%",
                        flexWrap: "wrap"
                    }}
                >
                    <Col xs={24} sm={10} md={6} lg={4} xl={3}>
                        <Spin spinning={loading}>
                            <CityFilter
                                value={city}
                                onChange={setCity}
                                restrictedCities={restrictedCities}
                            />
                        </Spin>
                    </Col>
                    <Col xs={24} sm={10} md={6} lg={4} xl={3}>
                        <IntegrationTypeFilter
                            value={integrationType}
                            onChange={setIntegrationType}
                        />
                    </Col>
                    <Col xs={24} sm={10} md={6} lg={4} xl={3}>
                        <PoolActivityFilter value={status} onChange={setStatus} />
                    </Col>
                    <Col xs={24} sm={10} md={6} lg={4} xl={3}>
                        <SearchText
                            value={searchText}
                            onChange={setSearchText}
                            label="Havuz Bölgesi"
                        />
                    </Col>
                    {isAdmin && (
                        <Col xs={24} sm={10} md={6} lg={4} xl={3}>
                            <ManagerCompanyFilter
                                value={managerCompany}
                                onChange={setManagerCompany}
                                showAllOption={true}
                            />
                        </Col>
                    )}
                </div>
                {city !== "all" && (
                    <div
                        style={{
                            display: "flex",
                            gap: "8px",
                            marginTop: isMobile ? "8px" : 0
                        }}
                    >
                        <CustomButton type="secondary" onClick={() => setIsModalOpen(true)}>
                            <EnvironmentOutlined style={{marginRight: "1px"}} />
                            Şehir Haritası
                        </CustomButton>
                        {isModalOpen && (
                            <PoolsListModal
                                isModalOpen={isModalOpen}
                                onClose={() => setIsModalOpen(false)}
                                city={city}
                            />
                        )}
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};

export default Filters;
